<template>
  <v-layout class="pt-2">
    <v-dialog content-class="item-card-image-content" lazy width="500">
      <template #activator="{ on }">
        <v-img
          v-on="on"
          contain
          :height="computedImageHeight"
          :width="computedImageWidth"
          :src="src || defaultImage"
        />
      </template>
      <v-img contain :src="src" width="500" height="500" />
    </v-dialog>
  </v-layout>
</template>

<script>
import defaultImage from "@/assets/placeholder.png";

export default {
  props: {
    imageHeight: {
      type: Number,
      default: 200
    },
    imageWidth: {
      type: Number,
      default: 200
    },
    src: {
      type: String
    }
  },
  data: () => ({
    defaultImage
  }),
  computed: {
    computedImageHeight() {
      return this.xs ? this.imageHeight / 2 : this.imageHeight;
    },
    computedImageWidth() {
      return this.xs ? this.imageWidth / 2 : this.imageWidth;
    }
  }
};
</script>